"use strict";

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.profileReducer = exports.INITIAL_STATE = void 0;

var reducer_1 = require("../loading/reducer");

var actions_1 = require("./actions");

exports.INITIAL_STATE = {
  data: {},
  loading: [],
  error: null
};

var profileReducer = function profileReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exports.INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions_1.SET_PROFILE_AVATAR_DESCRIPTION_REQUEST:
    case actions_1.LOAD_PROFILE_REQUEST:
      {
        return Object.assign(Object.assign({}, state), {
          loading: reducer_1.loadingReducer(state.loading, action),
          error: null
        });
      }

    case actions_1.SET_PROFILE_AVATAR_DESCRIPTION_FAILURE:
    case actions_1.LOAD_PROFILE_FAILURE:
      {
        return Object.assign(Object.assign({}, state), {
          loading: reducer_1.loadingReducer(state.loading, action),
          error: action.payload.error
        });
      }

    case actions_1.SET_PROFILE_AVATAR_DESCRIPTION_SUCCESS:
      {
        var _action$payload = action.payload,
            address = _action$payload.address,
            description = _action$payload.description,
            version = _action$payload.version;
        var newAvatar = Object.assign(Object.assign({}, state.data[address].avatars[0]), {
          description: description,
          version: version
        });
        return Object.assign(Object.assign({}, state), {
          data: Object.assign(Object.assign({}, state.data), _defineProperty({}, address, Object.assign(Object.assign({}, state.data[address]), {
            avatars: [newAvatar].concat(_toConsumableArray(state.data[address].avatars.slice(1)))
          }))),
          loading: reducer_1.loadingReducer(state.loading, action)
        });
      }

    case actions_1.LOAD_PROFILE_SUCCESS:
      {
        var _action$payload2 = action.payload,
            _address = _action$payload2.address,
            profile = _action$payload2.profile;
        return Object.assign(Object.assign({}, state), {
          data: Object.assign(Object.assign({}, state.data), _defineProperty({}, _address, profile)),
          loading: reducer_1.loadingReducer(state.loading, action)
        });
      }

    case actions_1.CHANGE_PROFILE:
      {
        var _action$payload3 = action.payload,
            _address2 = _action$payload3.address,
            _profile = _action$payload3.profile;
        return Object.assign(Object.assign({}, state), {
          data: Object.assign(Object.assign({}, state.data), _defineProperty({}, _address2, Object.assign(Object.assign({}, state.data[_address2]), _profile)))
        });
      }

    case actions_1.CLEAR_PROFILE_ERROR:
      {
        return Object.assign(Object.assign({}, state), {
          error: null
        });
      }

    default:
      return state;
  }
};

exports.profileReducer = profileReducer;